import { FormSwitch } from "@actinc/dls/components";
import { Controller } from "react-hook-form";

const ControlledFormSwitch = ({
  control,
  defaultValue,
  disabled,
  id,
  label,
  name,
  onChange: handleChange,
  readonly,
  trigger,
  value,
  ...props
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onBlur, onChange, ref, value } }) => (
        <FormSwitch
          checked={!!value}
          disabled={!!disabled}
          id={id}
          inputProps={{ disabled: !!readonly }}
          inputRef={ref}
          label={label}
          name={name}
          onBlur={(e) => {
            onBlur(e);
            trigger && trigger();
          }}
          onChange={(e) => {
            handleChange && handleChange(e);
            onChange(e);
            trigger && trigger();
          }}
        />
      )}
      {...props}
    />
  );
};
export { ControlledFormSwitch };
